import { render, staticRenderFns } from "./assetImpairmentList.vue?vue&type=template&id=5fedba9a"
import script from "./assetImpairmentList.vue?vue&type=script&lang=js"
export * from "./assetImpairmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports